module.exports = __webpack_public_path__ + "static/media/gt.d6b5b664.svg";